// services/fetchers.ts
import client, { client_product } from '../client';
import { DELETE_USER ,
CREATE_VENDOR,
  UPDATE_VENDOR,
  DELETE_VENDOR,
 CREATE_SHOP,
  UPDATE_SHOP,
  DELETE_SHOP
} from '../userMutation';
import {
  GET_USERS,
  GET_VENDOR_BY_USER_ID,
  GET_SHOP_BY_VENDOR_ID,
  GET_ALL_PRODUCTS_QUERY,
  GET_USERS_AND_ORDERS,
  GET_USER_AND_ORDERS,
  GET_ALL_ORDERS_QUERY,
  GET_ALL_COUNTS_QUERY,
  SAVE_SHOP_REWARD_CONFIG
} from '../userQuery';
// utils/graphqlHelpers.ts
import { ApolloClient, DocumentNode } from '@apollo/client';

import {  VendorUpdateInput,
  ShopInput,ShopUpdateInput,
  Vendor,
  User,
  VendorInput
 } from '../../interfaces/user';
 import {print} from 'graphql';
import { Product } from '../../interfaces/adminproduct';
import { Order } from '../../interfaces/orders_manage';

const env = process.env.REACT_APP_ENV_SETTINGS || 'dev';
const token = localStorage.getItem("token");

export const safeGraphQLQuery = async <T>(
  client: ApolloClient<any>,
  query: DocumentNode,
  variables?: Record<string, any>
): Promise<T> => {
  const response = await client.query({
    query,
    variables,
    fetchPolicy: 'network-only', // 👈 force bypass cache
  });

  if (response.errors?.length) {
    throw new Error(response.errors[0].message || 'Unknown GraphQL error');
  }

  if (!response.data) {
    throw new Error('No data returned from GraphQL');
  }

  return response.data as T;
};

export const safeGraphQLMutation = async <T>(
  client: ApolloClient<any>,
  mutation: DocumentNode,
  variables?: Record<string, any>
): Promise<T> => {
  const response = await client.mutate({ mutation, variables });

  if (response.errors?.length) {
    throw new Error(response.errors[0].message || 'Unknown GraphQL error');
  }

  if (!response.data) {
    throw new Error('No data returned from GraphQL mutation');
  }

  return response.data as T;
};



export const fetchUsers = async () => {
  try {
    if (env === 'dev') {
      const res = await fetch('http://localhost:5000/users');
      if (!res.ok) throw new Error('Failed to fetch users (REST)');
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error('Invalid users response');
      return data;
    } else {
      const data = await safeGraphQLQuery<{ users: any[] }>(client, GET_USERS);
      return data.users;
    }
  } catch (error) {
    console.error('Error in fetchUsers:', error);
    throw error;
  }
};

export const fetchVendorByUserId = async (userId: string) => {
  try {
    if (!userId || typeof userId !== 'string') {
      throw new Error('Invalid userId provided');
    }

    if (env === 'dev') {
      const res = await fetch(`http://localhost:5000/getVendorByUserId?userId=${userId}`);
      if (!res.ok) throw new Error('Failed to fetch vendor (REST)');
      const data = await res.json();
      if (!data || typeof data !== 'object') throw new Error('Invalid vendor response');
      return data;
    } else {
      // console.log('GraphQL Request →', { userId });

      const data = await safeGraphQLQuery<{ getVendorByUserId: any }>(
        client_product,
        GET_VENDOR_BY_USER_ID,
        { userId }
      );

      if (!data.getVendorByUserId) {
        throw new Error('Vendor not found for this user');
      }

      return data.getVendorByUserId;
    }
  } catch (error) {
    console.error('Error in fetchVendorByUserId:', error);
    throw error;
  }
};


export const fetchShopsByVendorId = async (vendorId: string) => {
  try {
    if (env === 'dev') {
      const res = await fetch(`http://localhost:5000/getShopByVendorId?vendorId=${vendorId}`);
      if (!res.ok) throw new Error('Failed to fetch shops (REST)');
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error('Invalid shops response');
      return data;
    } else {
      const data = await safeGraphQLQuery<{ getShopByVendorId: any[] }>(
        client_product,
        GET_SHOP_BY_VENDOR_ID,
        { vendorId }
      );
      if (!data.getShopByVendorId) throw new Error('No shops found for this vendor');
      return data.getShopByVendorId;
    }
  } catch (error) {
    console.error('Error in fetchShopsByVendorId:', error);
    throw error;
  }
};
export const deleteUser = async (id: string) => {
  try {
    if (env === 'dev') {
      const res = await fetch(`http://localhost:5000/users/${id}`, {
        method: 'DELETE',
      });
      if (!res.ok) throw new Error('Failed to delete user (REST)');
    } else {
      await safeGraphQLMutation(client, DELETE_USER, { id });
    }
  } catch (error) {
    console.error('Error in deleteUser:', error);
    throw error;
  }
};

export const createVendorApi = async (input: VendorInput) => {
  try {
    if (env === 'dev') {
      const res = await fetch(`http://localhost:5000/getVendorByUserId`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(input),
      });

      if (!res.ok) {
        throw new Error('Failed to create vendor (REST)');
      }

      return await res.json();
    } else {
      const data = await safeGraphQLMutation<{ createVendor: Vendor }>(
        client_product,
        CREATE_VENDOR,
        { input }
      );

      return data.createVendor;
    }
  } catch (error) {
    console.error('Error in createVendor:', error);
    throw error;
  }
};
export const updateVendorApi = async (vendorId: string, input: VendorUpdateInput) => {
  try {
    if (env === 'dev') {
      const res = await fetch(`http://localhost:5000/getVendorByUserId/${vendorId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(input),
      });
      if (!res.ok) throw new Error('Failed to update vendor (REST)');
      return await res.json();
    } else {
      const data = await safeGraphQLMutation<{ updateVendor: Vendor }>(client_product, UPDATE_VENDOR, { vendorId, input });
      return data.updateVendor;
    }
  } catch (error) {
    console.error('Error in updateVendor:', error);
    throw error;
  }
};
export const deleteVendor = async (id: string) => {
  try {
    if (env === 'dev') {
      const res = await fetch(`http://localhost:5000/getVendorByUserId/${id}`, {
        method: 'DELETE',
      });
      if (!res.ok) throw new Error('Failed to delete vendor (REST)');
    } else {
      await safeGraphQLMutation(client_product, DELETE_VENDOR, { id });
    }
  } catch (error) {
    console.error('Error in deleteVendor:', error);
    throw error;
  }
};



export const createShopApi = async (input: ShopInput & { shopLogoFile?: File }) => {
  try {
    if (env === 'dev') {
      const res = await fetch(`http://localhost:5000/getTopShops`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(input),
      });
      if (!res.ok) throw new Error('Failed to create shop (REST)');
      return await res.json();
    }

    // ✅ Step 1: Remove shopLogoFile before passing into variables
    const { shopLogoFile, ...restInput } = input;

    const variables = {
      input: {
        ...restInput,
        image: null // The GraphQL Upload field
      }
    };

    // ✅ Step 2: Build FormData for GraphQL multipart request
    const formData = new FormData();
    formData.append('operations', JSON.stringify({
      query: print(CREATE_SHOP),
      variables
    }));

    formData.append('map', JSON.stringify({
      "0": ["variables.input.image"] // Matches your Go struct: image graphql.Upload
    }));

    if (shopLogoFile) {
      formData.append("0", shopLogoFile);
    }

    // ✅ Step 3: Send to GraphQL
    const res = await fetch(process.env.REACT_APP_GRAPHQL_API_PRODUCT_URL!, {
      method: 'POST',
      headers: {  Authorization: token ? `Bearer ${token}` : "", },
      body: formData,
    });

    const json = await res.json();
    if (json.errors?.length) {
      throw new Error(json.errors[0].message);
    }

    return json.data.createShop;
  } catch (error) {
    console.log("Shop input being sent (cleaned):", input);
    console.error('Error in createShop:', error);
    throw error;
  }
};


export const updateShopApi = async (
  shopId: string,
  input: ShopUpdateInput & { shopLogoFile?: File }
) => {
  try {
    const { shopLogoFile, ...restInput } = input;

    const variables = {
      shopId,
      input: {
        ...restInput,
        image: null, // Match GraphQL Upload field
      },
    };

    const formData = new FormData();

    // operations: query + variables
    formData.append(
      'operations',
      JSON.stringify({
        query: print(UPDATE_SHOP),
        variables,
      })
    );

    // map: which files replace which variables
    formData.append(
      'map',
      JSON.stringify({
        '0': ['variables.input.image'],
      })
    );

    // file content
    if (shopLogoFile) {
      formData.append('0', shopLogoFile);
    }

    const res = await fetch(process.env.REACT_APP_GRAPHQL_API_PRODUCT_URL!, {
      method: 'POST',
      headers: {  Authorization: token ? `Bearer ${token}` : "", },
      body: formData,
    });

    const json = await res.json();

    if (json.errors?.length) {
      console.error('GraphQL Error:', json.errors);
      throw new Error(json.errors[0].message);
    }

    return json.data.updateShop;
  } catch (error) {
    console.error('Error in updateShopApi:', error);
    throw error;
  }
};


export const deleteShop = async (id: string) => {
  try {
    if (env === 'dev') {
      const res = await fetch(`http://localhost:5000/getTopShops/${id}`, {
        method: 'DELETE',
      });
      if (!res.ok) throw new Error('Failed to delete shop (REST)');
    } else {
      await safeGraphQLMutation(client_product, DELETE_SHOP, { id });
    }
  } catch (error) {
    console.error('Error in deleteShop:', error);
    throw error;
  }
};


export const fetchUsersAndOrders = async () => {
  if (env === "dev") {
    const [ordersRes, usersRes] = await Promise.all([
      fetch("http://localhost:5000/getAllOrders"),
      fetch("http://localhost:5000/users")
    ]);
    const orders = await ordersRes.json();
    const users = await usersRes.json();
    return { users, orders };
  } else {
    const { data } = await client.query({ query: GET_USERS_AND_ORDERS });
    return { users: data.users, orders: data.getAllOrders };
  }
};

export const fetchUserAndOrders = async (id: string) => {
  if (env === "dev") {
    const [ordersRes, usersRes] = await Promise.all([
      fetch("http://localhost:5000/getAllOrders"),
      fetch("http://localhost:5000/users")
    ]);
    const orders = await ordersRes.json();
    const users = await usersRes.json();
    return { users, orders };
  } else {
    const { data } = await client.query({  query: GET_USER_AND_ORDERS,
      variables: { userId: id }  });
    return { users: data.users, orders: data.getAllOrders };
  }
};

export const fetchProducts = async () => {
  if (env === "dev") {
    const res = await fetch("http://localhost:5000/products");
    return res.json();
  } else {
    const { data } = await client_product.query({ query: GET_ALL_PRODUCTS_QUERY });
    return data.products;
  }
};

export const fetchCounts = async () => {
  const { data } = await client_product.query({ query: GET_ALL_COUNTS_QUERY });

  return {
    vendorCount: data.vendors.length,
    shopCount: data.shops.length,
    categoryCount: data.categories.length,
    productCount: data.products.length,
  };
};

export const getDashboardData = async (userId: string) => {
  const [vendorsArray, productsResult] = await Promise.all([
    fetchVendorByUserId(userId),  // Vendor[]
    fetchProducts(),              // { products: Product[] }
  ]);

 const { data: ordersData } = await client.query({ query: GET_ALL_ORDERS_QUERY });

  const myVendorIds = vendorsArray.map((vendor: any) => vendor.id);

  const filteredProducts = productsResult.filter(
    (product: Product) => myVendorIds.includes(product.vendorId)
  );

  const filteredProductIds = filteredProducts.map((p: any) => p.id);

  const filteredOrders = ordersData.getAllOrders.filter((order: Order) =>
  order.items?.some((item) => filteredProductIds.includes(item.productId))
);

  // const filteredOrders: Order[] = []; // if not fetched yet

  return {
    users: vendorsArray as User[],
    products: filteredProducts,
    orders: filteredOrders,
  };
};


export const saveShopRewardConfigApi = async (
  shopId: string,
  shopCommPct: number,
  custPct: number
) => {
  const response = await client.mutate({
    mutation: SAVE_SHOP_REWARD_CONFIG,
    variables: {
      shopId,
      shopCommPct,
      custPct,
    },
  });

  return response.data.saveShopRewardConfig;
};





